/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  function formattedPriceWithComparisonNoRatio(price, compare_at_price, on_sale) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);

    var res = '';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><strong>' +
        formatPrice(compare_at_price) +
        '</strong></span> ';
        res += '<strong class="sale-price">' + formatPrice(price) + '</strong>';
        res += '<strong class="product__price campaign-discount campaign-product_grid">'+ '-' + Math.round(((compare_at_price-price)/(compare_at_price))*100) + '%' + '</strong>'


    } else if (on_sale) {
      res += '<strong class="sale-price">' + formatPrice(price) + '</strong>'
    }
    else {
      res += '<strong>' + formatPrice(price) + '</strong>';
    }
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;

        var tags = this.tags;
        var saleTags = document.body.dataset.saleTags.split(',');
        var containedSalesTags = [];

        tags.forEach(function(x) {
          if(saleTags.indexOf(x) != -1 && x != "Rehti_hinta_logo") {
            containedSalesTags.push(x);
          }
        });

        if (min !== max) {
        if (containedSalesTags.length > 0) {
            return '<strong>' + algolia.translations.from.replace(/\{\{\s?price\s?\}\}/, '<span class="sale-price">' + formatPrice(min) + '</span>') + '</strong>';
          } else {
            return '<strong>' + algolia.translations.from.replace(/\{\{\s?price\s?\}\}/, formatPrice(min)) + '</strong>';
        }
      }
      }
      return formattedPriceWithComparisonNoRatio(this.price, this.compare_at_price);
    },
    instantsearchPrice: function instantsearchPrice() {
      var tags = this.tags;
      var saleTags = document.body.dataset.saleTags.split(',');
      var containedSalesTags = [];
      var onSale = false;
      tags.forEach(function(x) {
        if(saleTags.indexOf(x) != -1 && x != "Rehti_hinta_logo") {
          containedSalesTags.push(x);
          onSale = true;
        }
      });

      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        var ratio=this.price_ratio

        if (min !== max) {
        if (onSale) {
            return '<strong>' + algolia.translations.from.replace(/\{\{\s?price\s?\}\}/, '<span class="sale-price">' + formatPrice(min) + '</span>') + '</strong>' +
            '<strong class="product__price campaign-discount campaign-product_grid">'+ '-' + Math.round(((1-ratio)*100)) + '%' + '</strong>';
          } else {
            return '<strong>' + algolia.translations.from.replace(/\{\{\s?price\s?\}\}/, formatPrice(min)) + '</strong>';
        }
      }
      }
      return formattedPriceWithComparisonNoRatio(
        this.price,
        this.compare_at_price,
        onSale
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + this.variant_title + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + this.variant_title + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return '//cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    salesBadge: function(text, render) {
      var tags = this.tags;
      var saleTags = document.body.dataset.saleTags.split(',');
      var containedSalesTags = [];
      var icons = ["rehti-hinta","rehti-ale","rehti-tarjous","rehti-poistohinta","black-week","pysyvasti-edullinen"];
      var badges = JSON.parse(document.getElementById('product-badges-json').textContent);

      tags.forEach(function(x) {
        if(saleTags.indexOf(x) != -1) {
          containedSalesTags.push(x);
        }
      });

      if (containedSalesTags.length > 0) {
        var salestagIndex = saleTags.indexOf(containedSalesTags[0]);
        return render(badges[icons[salestagIndex]]);
      }
    },
    finnishBadge: function() {
      var tags = this.tags;
      for ( const tag of tags ) {
        if( tag === 'badge_avainlippu') {
          return `<svg class= "algolia-finnish-badge" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 51 73"><g transform="translate(-5.2 -12.4)"><defs><path id="a" d="M-15.4 2h131.5v93.5H-15.4z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><path clip-path="url(#b)" fill-rule="evenodd" clip-rule="evenodd" fill="#00478C" d="M23.7 16.4v-2.3l-4.4-1.7v54.2c-8 .7-14.1 4.7-14.1 9.4 0 5.2 7.3 9.4 16.2 9.4 9 0 16.2-4.2 16.2-9.4 0-4.7-6.1-8.7-14.1-9.4V37.3h32.7V16.4H23.7zM33.2 76c0 3.3-5.2 5.9-11.7 5.9S9.8 79.3 9.8 76s5.2-5.9 11.7-5.9C28 70 33.2 72.7 33.2 76"/></g><g transform="translate(-5.2 -12.4)"><defs><path id="c" d="M-15.4 2h131.5v93.5H-15.4z"/></defs><clipPath id="d"><use xlink:href="#c" overflow="visible"/></clipPath><path clip-path="url(#d)" fill="#00478C" d="M13.9 59.3c0-.8-.6-1.1-1.3-1.1h-1.4v3.6h.8v-1.4h.4l.7 1.4h.9l-.9-1.5c.5-.1.8-.5.8-1m-1.5.4H12v-.8h.5c.3 0 .6.1.6.4 0 .4-.4.4-.7.4"/></g><g transform="translate(-5.2 -12.4)"><defs><path id="e" d="M-15.4 2h131.5v93.5H-15.4z"/></defs><clipPath id="f"><use xlink:href="#e" overflow="visible"/></clipPath><path clip-path="url(#f)" fill="#00478C" d="M12.5 56.5C10.6 56.5 9 58.1 9 60s1.6 3.5 3.5 3.5S16 61.9 16 60s-1.6-3.5-3.5-3.5m0 6.3c-1.5 0-2.8-1.3-2.8-2.8s1.3-2.8 2.8-2.8 2.8 1.3 2.8 2.8c0 1.6-1.2 2.8-2.8 2.8"/></g><g transform="translate(-5.2 -12.4)"><defs><path id="g" d="M-15.4 2h131.5v93.5H-15.4z"/></defs><clipPath id="h"><use xlink:href="#g" overflow="visible"/></clipPath><path clip-path="url(#h)" fill-rule="evenodd" clip-rule="evenodd" fill="#FFF" d="M23.7 24.2h8.9v-7.1h-8.9v7.1zm14.2 0h17.8v-7.1H37.9v7.1zM23.7 36.6h8.9v-7.1h-8.9v7.1zm14.2 0h17.8v-7.1H37.9v7.1z"/></g></svg>`;
        } else if (tag === 'badge_rehdisti_kotimainen') {
          return `<svg class= "algolia-honestly-finnish" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 595.3 841.9" style="enable-background:new 0 0 595.3 841.9;" xml:space="preserve"><style type="text/css"> .st0{clip-path:url(#SVGID_2_);fill:#E8E3D2;} .st1{fill:#FFFFFF;} .st2{fill:#0A478E;} </style><g><defs><rect id="SVGID_1_" x="178.5" y="302.3" width="237.4" height="237.4"/></defs><clipPath id="SVGID_2_"><use xlink:href="#SVGID_1_"  style="overflow:visible;"/></clipPath><path class="st0" d="M297.2,539.7c65.6,0,118.7-53.1,118.7-118.7c0-65.6-53.1-118.7-118.7-118.7S178.5,355.4,178.5,421 C178.5,486.5,231.7,539.7,297.2,539.7"/></g><rect x="224.7" y="365.8" class="st1" width="149" height="96.9"/><polygon class="st2" points="266.7,365.8 266.7,401.4 224.7,401.4 224.7,427 266.7,427 266.7,462.7 292.3,462.7 292.3,427 373.8,427 373.8,401.4 292.3,401.4 292.3,365.8 "/><g><defs><rect id="SVGID_3_" x="178.5" y="302.3" width="237.4" height="237.4"/></defs><clipPath id="SVGID_4_"><use xlink:href="#SVGID_3_"  style="overflow:visible;"/></clipPath></g></svg>`;
        }
      };
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return '//cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
